import axios from "axios";

const DashboardApi = axios.create({
  baseURL:
    process.env.REACT_APP_DASHBOARD_API || "https://api.test.lawnbot.biz",
});

export default DashboardApi;
